import { Flex, Icon, Spacing, Text, Tooltip } from '@billy/design-system'
import { ReactElement } from 'react'
import { useTranslation } from 'react-i18next'

import { EntityType } from '../../../../enums/entityType'
import { EInvoiceScheme } from '../../../../types/eInvoiceScheme'
import { getEInvoiceAddressLabel } from './utils/getEInvoiceAddressLabel'
import { getPublicTypeEInvoiceAddressTooltip } from './utils/getPublicTypeEInvoiceAddressTooltip'

interface EInvoiceAddressInputLabelProps {
  countryId?: string
  entityType?: EntityType
  schemeType: EInvoiceScheme
  shouldDisplayInputFieldLabelTooltip: boolean
}

export const EInvoiceAddressInputLabel = ({
  countryId,
  entityType,
  schemeType,
  shouldDisplayInputFieldLabelTooltip,
}: EInvoiceAddressInputLabelProps): ReactElement => {
  const { t } = useTranslation()

  return (
    <Flex flexDirection="row" gap={Spacing.S4}>
      <Text colorVariant="secondary">{getEInvoiceAddressLabel({ countryId, entityType, schemeType, t })}</Text>
      {shouldDisplayInputFieldLabelTooltip && (
        <Tooltip label={getPublicTypeEInvoiceAddressTooltip(t, schemeType)} placement="top">
          <Icon icon="circleQuestionMark" size="xs" />
        </Tooltip>
      )}
    </Flex>
  )
}
